import { center } from '@styled-system/patterns';
import { token } from '@styled-system/tokens';
import { type ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PuffLoader } from 'react-spinners';

import amplitude from '@/amplitude';
import { useAuth } from '@/features/auth/hooks/useAuth';

interface AuthGuardProps {
  children: ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        amplitude.track('Log In');
      } else {
        navigate('/');
      }
    }
  }, [navigate, isLoading, isAuthenticated]);

  useEffect(() => {
    if (user) {
      amplitude.setUserId(user.id);
    } else {
      amplitude.setUserId(undefined);
    }
  }, [user]);

  if (isLoading || !isAuthenticated) {
    return (
      <div className={center({ h: '100vh', w: '100vw' })}>
        <PuffLoader color={token.var('colors.accent.primary')} size={60} />
      </div>
    );
  }

  return <>{children}</>;
};
